import type { QueryClient } from "@tanstack/react-query";
import type { createApi, EnvName } from "./api";
import { executeBoardCommands } from "./executeBoardCommands";
import type { VoiceCommandWire } from "./voiceDispatch";

type VoiceApi = ReturnType<typeof createApi>;

/** Voice headless path — delegates to executeBoardCommands. */
export async function executeVoicePlan(
  commands: VoiceCommandWire[],
  deps: {
    env: EnvName;
    api: VoiceApi;
    qc: QueryClient;
    navigate: (path: string) => void;
    getHandle?: (sectionCode: string) => import("./voiceDispatch").SectionHandle | null;
  },
): Promise<void> {
  return executeBoardCommands(commands, deps);
}
